import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addBankaccount,
  getBankaccounts,
  getBankaccount,
  editBankaccount,
  deleteBankaccount,
  getAllBankaccounts,
} from "../../store/actions/bankaccount_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllBankaccounts = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.bankaccount);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);

  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteBankaccount(deleteEntry));
    }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
      dispatch(
        getBankaccounts({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [data, setPageNumber, deleteBtnClicked];
};

// Get Single Data
export const useSingleBankaccount = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.bankaccount);
  useEffect(() => {
    dispatch(getBankaccount(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateBankaccount = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.bankaccount);
  const addData = async (data) => {
    await dispatch(addBankaccount(data));
  };
  return [data, addData];
};
export const useUpdateBankaccount = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.bankaccount);
  const updateData = async (id, data) => {
    await dispatch(editBankaccount(id, data));
  };
  return [updateData];
};

export const useSelectAllBankaccount = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.bankaccount);
  useEffect(() => {
    dispatch(getAllBankaccounts({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
  // useSelectAllClient();

  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

  return [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ];
};
